import { Controller } from "@hotwired/stimulus"

// Region-gated cookie notice. Persists user choice via the /cookie-consent
// endpoint, then removes itself from the DOM.
export default class extends Controller {
  static values = { endpoint: String }

  accept() {
    this.#submit("all")
  }

  reject() {
    this.#submit("required")
  }

  #submit(choice) {
    const formData = new FormData()
    formData.append("choice", choice)

    fetch(this.endpointValue, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).finally(() => {
      this.element.remove()
    })
  }
}
